import * as Yup from 'yup';
import { validatePhoneNumber } from 'utils/phoneHelpers';
Yup.addMethod(Yup.string, 'phone', function () {
  return this.test('phone', 'Phone number is not valid', (value) => {
    if (!value) return true;
    return validatePhoneNumber(value);
  });
});

// Alphanumeric (plus underscore/whitespace), requiring at least 1 letter so a name can't be all digits
export const NAME_REGEX = /^(?=.*[a-zA-Z])[a-zA-Z_0-9\s]+$/;
